define([
    'text!./basler-city-picker.html',
], (templateStr) => {

    baslerCityPicker.$inject = ['AddressLookupService', 'DefaultErrorHandlerService'];
    function baslerCityPicker(AddressLookupService, DefaultErrorHandlerService) {

        return {
            restrict: 'E',
            //require: ['^form'],
            scope: {
                postalCode: '=postalCodeView',
                label: '@',
                postalCodeClass: '@?',
                city: '=cityView',
                canton: '=cantonView',
                cityPlaceHolder: '@?',
                editable: '=?',
            },
            template: templateStr,
            link: {
                pre: init,
                post: linkFunction,
            },
        };

        function doLookup(scope) {
            scope.city.value = undefined;
            AddressLookupService.findCityByPostalCode(scope.callGroup, scope.postalCode.value)
                .then((cities) => {
                    scope.oldPostalCode = scope.postalCode.value;
                    if (!cities || cities.length === 0) {
                        scope.availableCities = [];
                        scope.emptyListOfCities = true;
                        return;
                    }
                    setCities(scope, cities);
                }, (error) => {
                    DefaultErrorHandlerService.getErrorHandlerForError(error[0])();
                    scope.emptyListOfCities = true;
                    scope.availableCities = [];
                });
        }

        function setCities(scope, cities) {
            if (!cities) {
                return;
            }
            scope.availableCities = cities.map(cityObject => cityObject.cityName);
            scope.selectedCanton = cities[0].canton; // Canton is the same for all the returned objects
            if (cities.length === 1) {
                scope.city.value = cities[0].cityName;
                scope.canton.value = cities[0].canton;
            }
        }

        function init(scope) {
            scope.readonly = !scope.editable;
            scope.availableCities = scope.city.value ? [scope.city.value] : [];
            scope.emptyListOfCities = false;
            scope.callGroup = `postalCodeToCity${Math.random()}`;
            scope.selectedCanton = '';

            if ((scope.city == null || scope.city.value == null) && scope.postalCode && scope.postalCode.value) {
              // Do city lookup if postal code is available but no city is set.
              doLookup(scope);
            }
        }

        function linkFunction(scope) {

            scope.cityInputDisabled = function () {
                return scope.readonly || scope.availableCities.length <= 1;
            };

            scope.postalCodeChanged = function () {
                if (shouldDoLookup(scope.postalCode)) {
                    scope.emptyListOfCities = false;
                    doLookup(scope);
                }
            };

            scope.citySelectBy = function (city) {
                scope.city.value = city;
                scope.canton.value = scope.selectedCanton;
            };

            function shouldDoLookup(postalCode) {
                return postalCode.value && postalCode.aspects.valid && postalCode.value !== scope.oldPostalCode;
            }

        }
    }
    return baslerCityPicker;
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/baslercitypicker/BaslerCityPicker.js